import React from 'react';
import AboutMeSection from './AboutMeSection';

function AboutMemainContainer() {
  return (
    <main role='main' className='grid'>
      {/* About section one */}
      <div className='px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-44'>
        <AboutMeSection />
      </div>
    </main>
  );
}

export default AboutMemainContainer;
